export default "__VITE_ASSET__RQZdLHiw__"